import store from '@/store/index'
import Vue from 'vue'
import VueCryptojs from 'vue-cryptojs'
import VueCookies from 'vue-cookies'

Vue.use(VueCryptojs)
Vue.use(VueCookies)


// const decryptData = data => Vue.CryptoJS.AES.decrypt(data, process.env.VUE_APP_COOKIE_SECRET).toString(Vue.CryptoJS.enc.Utf8)

// const decryptCookie = key => {
//   const cookie = Vue.$cookies.get(key) || null
//   if (!cookie) return
//   return decryptData(cookie)
// }
// const cookieToken = decryptCookie('token') || null

const sessionValid = () => {
  const exp = store.getters['auth/exp'] || null
  if (!exp) return false
  return new Date(exp) >= new Date()
}

const homePage = next => {
  const path = store.getters['auth/mainPageV2']
  if (!path) {
    next('/')
    return
  }
  next(path)
}

const limitedPages = (to, from, next) => {
  /** @type {Set<string>} */
  const pageSet = store.getters['auth/pageSet']
  if (!pageSet.size) return next()
  const match = to.matched.some(match => pageSet.has(match.path))
  if (match) return next()
  const mainPage = store.getters['auth/mainPageV2']
  next(mainPage)
}

const verifyLogin = (to, from, next) => {
  if (!sessionValid()) {
    store.dispatch('auth/clearToken')
    next({ name: 'login' })
    return
  }
  limitedPages(to, from, next)
}

const verifyGuest = (to, from, next) => {
  if (!sessionValid()) {
    next()
    return
  }
  homePage(next)
}

const restrictedAccess = (allowedAccess, roles = []) => (to, from, next) => {
  const { accessLevel } = store.state.auth
  if (accessLevel < allowedAccess) {
    homePage(next)
    return
  }
  next()
}

export {
  verifyLogin,
  verifyGuest,
  restrictedAccess,
}
